import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { FlavorMenu } from "@/components/FlavorMenu";
import { Packages } from "@/components/Packages";
import { Calculator } from "@/components/Calculator";
import { Gallery } from "@/components/Gallery";
import { Payments } from "@/components/Payments";
import { Loyalty } from "@/components/Loyalty";
import { Reviews } from "@/components/Reviews";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { BookingModal } from "@/components/BookingModal";

export default function Landing() {
  return (
    <div className="relative min-h-screen bg-cosmic-base text-white" data-testid="landing-page">
      <div className="grain-overlay" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <FlavorMenu />
        <Packages />
        <Calculator />
        <Gallery />
        <Payments />
        <Loyalty />
        <Reviews />
      </main>
      <Footer />
      <CartDrawer />
      <BookingModal />
    </div>
  );
}
